import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestGettoniEditComponent.vue?vue&type=template&id=19c1d6e4&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestGettoniEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestGettoniEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestGettoniEditComponent.vue?vue&type=style&index=0&id=19c1d6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1d6e4",
  null
  
)

export default component.exports